import { render } from "./add-member.vue?vue&type=template&id=248fad2c&scoped=true"
import script from "./add-member.vue?vue&type=script&lang=js"
export * from "./add-member.vue?vue&type=script&lang=js"

import "./add-member.vue?vue&type=style&index=0&id=248fad2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248fad2c"]])

export default __exports__